"use client";
import {
  usePopoverArrow
} from "../__chunks/VV5PQLL2.js";
import "../__chunks/2SM3RB2N.js";
import {
  useHovercardContext
} from "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/YV4JVR4I.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/hovercard/hovercard-arrow.tsx
var TagName = "div";
var useHovercardArrow = createHook(
  function useHovercardArrow2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useHovercardContext();
    store = store || context;
    props = usePopoverArrow(__spreadValues({ store }, props));
    return props;
  }
);
var HovercardArrow = forwardRef(function HovercardArrow2(props) {
  const htmlProps = useHovercardArrow(props);
  return createElement(TagName, htmlProps);
});
export {
  HovercardArrow,
  useHovercardArrow
};
